import { Injectable } from '@angular/core';
import { ClientAppointment } from '../../domain/models/client-appointment.model';
import { ClientAppointmentDto } from '../dtos/client-appointment.dto';

@Injectable()
export class ClientAppointmentMapper {
  public toClientAppointment(dto: ClientAppointmentDto): ClientAppointment {
    return {
      id: dto.ExternalId,
      start: dto.Start ?? null,
      title: dto.Title?.trim() || dto.Complaint?.trim() || null,
      patientIds: dto.ExternalPatientIds ?? [],
      professionalId: dto.ExternalProfessionalId?.trim() || null,
    };
  }
}
